import { useEffect, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { toast } from "react-toastify";
import useFetch from "../../../hooks/use-fetch";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEye, faEyeSlash } from "@fortawesome/free-solid-svg-icons";


const ForgotPassword = () => {
    const navigate = useNavigate();
    const [searchParams] = useSearchParams();
    const { post } = useFetch()

    const [email, setEmail] = useState<string>('') 
    const [password, setPassword] = useState<string>('')
    const [showPassword, setShowPassword] = useState(false);
    
    const [errorMessage, setErrorMessage] = useState<string>('')
    
    const token = searchParams.get('token')

    const handleForgotPassword = async (e: React.FormEvent) => {
        e.preventDefault();
        setErrorMessage('');
        try{
            await post('/auth/forgot-password/', {email: email})
            toast.success('Richiesta di reset della password inviata con successo')
        } catch (err) {
            toast.error('Errore durante il reset della password')
        }
    }
    
    const handleResetPassword = async (e: React.FormEvent) => {
        e.preventDefault();
        setErrorMessage('');
        try{
            await post(`/auth/reset-password/?token=${token}`, {password: password})
            toast.success('Password resettata con successo')
        } catch (err) {
            toast.error('Errore durante il reset della password')
        }
    }

    return (
        <div className="login-box">
            <h2 className="text-xl mb-5 text-gray-800">Reset</h2>
            <form onSubmit={token ? handleResetPassword : handleForgotPassword}>
                <div className="textbox">

                    {token 
                    ?<>
                        <div className="textbox password-container">
                            <label htmlFor="password">Password:</label>
                            <input
                                type={showPassword ? 'text' : 'password'}
                                id="password"
                                value={password}
                                onChange={(e) => setPassword(e.target.value)}
                                placeholder="Password..."
                                required
                            />
                            <button
                                type="button"
                                onClick={() => setShowPassword(!showPassword)}
                                className="show-password-button"
                            >
                            <FontAwesomeIcon
                                icon={showPassword ? faEyeSlash : faEye}
                                className="password-icon"
                            />
                            </button>
                        </div>
                    </>
                    :<>
                        <label htmlFor="email">Email:</label>
                        <input
                            type="email"
                            id="email"
                            value={email}
                            onChange={(e) => setEmail(e.target.value)}
                            placeholder="Inserisci la tua email"
                            required
                            onInvalid={(e) => {
                                e.preventDefault()
                                setErrorMessage('Inserisci un indirizzo email valido.');
                            }}
                        />
                    </>
                    }
                </div>
                {errorMessage && <p className="error-message">{errorMessage}</p>}
                <div className='login-box-footer'>
                    <div className='forgot-password' onClick={()=>navigate('/')}>
                        Login
                    </div>
                    <button type="submit" className="btn primary">{token ? "Resetta password" : 'Invia email'}</button>
                </div>
                
            </form>            
        </div>
    )
}

export default ForgotPassword